import { Pedigree } from './pedigree';

export default Pedigree;
